import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Page from "../../../shared/components/ui/page/Page";
import MobileBanner from "../../../shared/components/ui/mobileBanner/MobileBanner";
import iconsList from "../../../shared/components/ui/icons/iconsList";
import pathRouts from "../../../shared/enums/pathRoute";
import classes from "./ManagerMobilePage.module.css";

const ManagerMobilePage = () => {

    const { texts } = useSelector(state => state.translate);
    const navigate = useNavigate();

    return (
        <Page
            title={texts.virtualSchoolManagementTitle}
            icon={iconsList.managerDashboard}
            onBack={() => navigate(`/${pathRouts.HOME}`)}
            pageClassName={classes.ManagerMobilePage}
        >
            <MobileBanner
                text={texts.virtualSchoolManagementMobileBanner}
                className={classes.MobileBanner}
            />
        </Page>
    );
};

export default ManagerMobilePage;
